import React, { useEffect, useState } from 'react';

// Antd
import {
    WhatsAppOutlined,
    ClockCircleOutlined,
} from '@ant-design/icons';
import {
    AutoComplete,
    Button,
    Input,
    List,
    Select,
    Spin,
    Tag
} from 'antd';
import { Link } from 'react-router-dom';

// API
import { getUsersCourses } from '../../../Constants/Api/functions/function';

// Redux
import { useSelector } from 'react-redux';

// Styles
import './style.scss';

import { DEFAULT_USER_PROFILE_IMAGE } from '../../../Constants/Api/azure/azure';

const PromoCountdown = ({ endDate }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!endDate) return;
    
    const calculateTimeLeft = () => {
      const difference = +new Date(endDate) - +new Date();
      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        return `Ends in ${days}d ${hours}h ${minutes}m`;
      }
      return 'Promotion Ended';
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000);

    return () => clearInterval(timer);
  }, [endDate]);

  if (!timeLeft || timeLeft === 'Promotion Ended') return null;

  return (
    <div style={{
      display: 'inline-block',
      padding: '2px 8px',
      background: '#fff2f0',
      border: '1px solid #ffccc7',
      borderRadius: '4px',
      color: '#ff4d4f',
      fontSize: '11px',
      fontWeight: 'bold',
      marginTop: '4px'
    }}>
      <ClockCircleOutlined style={{ marginRight: '4px' }} />
      {timeLeft}
    </div>
  );
};

const MyCources = () => {
    const [isLoading, setIsLoading] = useState(false);
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const [userCources, setUserCources] = useState();
    const [data, setData] = useState();
    const [allCources, setAllCources] = useState();
    const [coursesData, setCoursesData] = useState()

    useEffect(() => {
        if (data) {
            const sortedData = [...data].sort((a, b) => {
                return a?.orderNumber - b?.orderNumber;
            });

            setCoursesData(
                sortedData.map((item) => {
                    return {
                        id: item?.id,
                        title: item?.name,
                        discription: item?.description,
                        isPublished: item?.isPublished,
                        thumbnail: item?.coverImage,
                        price: item?.price,
                        promoPrice: item?.promoPrice,
                        isPromoActive: item?.isPromoActive,
                        promoStartDate: item?.promoStartDate,
                        promoEndDate: item?.promoEndDate,
                        alumniDiscount: item?.alumniDiscount,
                        authorName: item?.createdBy?.name,
                        authorImage: item?.createdBy?.profileImage,
                        orderNumber: item?.orderNumber,
                        whatsappGroupLink: item?.whatsappGroupLink,
                        tags: item?.tags,
                    };
                })
            );
        }
    }, [data]);

    useEffect(() => {
        if (userProfile?.role !== 'superadmin') {
            handleGetUserCources();
        }
    }, []);

    const handleGetUserCources = async () => {
        setIsLoading(true)
        try {
            const userCources = await getUsersCourses(userProfile?.id)
            setData(userCources)
            setUserCources(userCources)
            setAllCources(userCources)
        } catch (error) {
            console.error('handleGetUserCources', error)
        }
        setIsLoading(false)
    }

    const filterBytags = (value) => {
        if (value === 'All') {
            setData(allCources);
        } else {
            const filteredData = data?.filter((item) => {
                const tagsArray = item?.tags?.split(',');
                return tagsArray?.find((tag) => tag === value);
            });

            setData(filteredData);
        }
    }

    const renderTags = (tags) => {
        return tags?.split(',').map((tag) => {
            if (tag === 'VideoTutorials') {
                return <Tag color="blue">Video Tutorials</Tag>
            } else if (tag === 'Exams') {
                return <Tag color="blue">Exams</Tag>
            } else if (tag === 'TrainingAndCourses') {
                return <Tag color="blue">Training and Courses</Tag>
            } else if (tag === 'News') {
                return <Tag color="blue">News</Tag>
            } else if (tag === 'Seminar') {
                return <Tag color="blue">Seminar</Tag>
            }
        })
    }

    return <div className='cources'>
        <div className='cources-action-buttons'>
            <div className='filters'>
                <div className='filter-search'>
                    <h2>
                        All Courses
                    </h2>
                    <div className='filter-inputs'>
                        <AutoComplete
                            popupMatchSelectWidth={252}
                            options={allCources?.map((item) => {
                                return {
                                    value: item.name,
                                    label: item.name,
                                }
                            })}
                            size="large"
                            onSelect={(value) => {
                                if (value) {
                                    const filteredData = allCources?.filter((item) => {
                                        return item?.name?.toLowerCase().includes(value.toLowerCase());
                                    });
                                    setData(filteredData);
                                } else {
                                    setData(allCources);
                                }
                            }}
                        >
                            <Input.Search size="large"
                                placeholder="Search by title"
                                enterButton
                                onSearch={(value) => {
                                    if (value) {
                                        const filteredData = allCources?.filter((item) => {
                                            return item?.name?.toLowerCase().includes(value.toLowerCase());
                                        });
                                        setData(filteredData);
                                    } else {
                                        setData(allCources);
                                    }
                                }}
                                onChange={(e) => {
                                    if (!e.target.value) {
                                        setData(allCources);
                                    } else {
                                        const filteredData = allCources?.filter((item) => {
                                            return item?.name?.toLowerCase().includes(e.target.value.toLowerCase());
                                        });
                                        setData(filteredData);
                                    }
                                }}
                            />
                        </AutoComplete>
                    </div>
                </div>

                <div className='radio-buttons'>
                    <Select placeholder="Filter by tags"
                        style={{
                            minWidth: '150px'
                        }}
                        onChange={(value) => filterBytags(value)}
                    >
                        <Select.Option value={'All'}>All</Select.Option>
                        <Select.Option value={'VideoTutorials'}>Video Tutorials</Select.Option>
                        <Select.Option value={'Exams'}>Exams</Select.Option>
                        <Select.Option value={'TrainingAndCourses'}>Training and Courses</Select.Option>
                        <Select.Option value={'News'}>News</Select.Option>
                        <Select.Option value={'Seminar'}>Seminar</Select.Option>
                    </Select>
                </div>
            </div>
        </div>
        <Spin
            spinning={isLoading}
            tip="Loading Courses..."
        >
            <div className='cources-body'>
                <Spin
                    tip="Loading..."
                    spinning={isLoading}
                >
                    <List
                        grid={{
                            gutter: 30,
                            xs: 1,
                            sm: 1,
                            md: 2,
                            lg: 2,
                            xl: 3,
                            xxl: 4,
                        }}
                        dataSource={coursesData}
                        renderItem={(item) => (
                            <List.Item>
                                <Link to={`/dashboard/cources/${item.id}`}>
                                    <div className='course-card'>
                                        <div className='card-image-container'>
                                            <img
                                                src={
                                                    item?.thumbnail
                                                        ? item?.thumbnail
                                                        : require('./1695793881259.jpeg')
                                                } alt=""
                                            />
                                            <div className='cource-card-header-buttons'>
                                                <div
                                                    className='duration'
                                                    style={{
                                                        backgroundColor: item?.isPublished ? '#4CAF50' : '#f44336'
                                                    }}
                                                >
                                                    <p>
                                                        {
                                                            item?.isPublished ? 'Published' : 'Not Published'
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-body'>
                                            <div className='card-description'>
                                                <div className="price" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px', width: '100%' }}>
                                                    {item?.price === 0 ? (
                                                        <span className="free-text" style={{ fontSize: '1.25rem', fontWeight: '700', color: '#52c41a' }}>Free</span>
                                                    ) : (
                                                        <>
                                                            {item?.isPromoActive && item?.promoStartDate && item?.promoEndDate && new Date() >= new Date(item.promoStartDate) && new Date() <= new Date(item.promoEndDate) ? (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
                                                                        <span style={{ color: '#ff4d4f', fontSize: '1.25rem', fontWeight: '700', whiteSpace: 'nowrap' }}>{Number(item?.promoPrice || 0).toLocaleString()} LKR</span>
                                                                        <span style={{ textDecoration: 'line-through', color: '#8c8c8c', fontSize: '0.9rem', whiteSpace: 'nowrap' }}>{Number(item?.price || 0).toLocaleString()} LKR</span>
                                                                    </div>
                                                                    <PromoCountdown endDate={item.promoEndDate} />
                                                                </div>
                                                            ) : (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                    <span style={{ fontSize: '1.25rem', fontWeight: '700', color: '#1f1f1f', whiteSpace: 'nowrap' }}>{Number(item?.price || 0).toLocaleString()} LKR</span>
                                                                    {item?.alumniDiscount > 0 && item?.prerequisiteCourseIds && (() => { try { const ids = typeof item.prerequisiteCourseIds === 'string' ? JSON.parse(item.prerequisiteCourseIds) : item.prerequisiteCourseIds; return Array.isArray(ids) && ids.length > 0; } catch { return false; } })() && (
                                                                        <span style={{ color: '#52c41a', fontSize: '0.85rem', fontWeight: '600', whiteSpace: 'nowrap' }}>
                                                                            Alumni Price: {Number((item.price || 0) - (item.alumniDiscount || 0)).toLocaleString()} LKR
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>

                                                <div className='author'>
                                                    <img
                                                        src={
                                                            item?.authorImage
                                                                ? item?.authorImage
                                                                : DEFAULT_USER_PROFILE_IMAGE
                                                        } alt=""
                                                    />
                                                    <h3>
                                                        {item?.authorName}
                                                    </h3>
                                                </div>
                                            </div>

                                            <h3 className='title'>
                                                {item?.title}
                                            </h3>

                                            <div className="tags">
                                                {renderTags(item?.tags)}
                                            </div>
                                        </div>

                                        <div className='card-footer'>
                                            <div className='button-continer'>
                                                <>
                                                    {userProfile?.role !== 'superadmin' ?
                                                        <Link
                                                            className='enroll-now'
                                                            to={`/dashboard/cources/${item.id}`}><Button
                                                                type='link'
                                                            >
                                                                {
                                                                    userCources?.find((course) => course?.id === item?.id)
                                                                        ?
                                                                        'Continue'
                                                                        :
                                                                        'Enroll Now'
                                                                }
                                                            </Button>
                                                        </Link>
                                                        :
                                                        <Link
                                                            className='enroll-now'
                                                            to={`/dashboard/cources/${item.id}`}>
                                                            <Button
                                                                type='link'
                                                            >
                                                                View
                                                            </Button>
                                                        </Link>
                                                    }
                                                </>
                                                <>
                                                    {
                                                        item?.whatsappGroupLink &&
                                                        <a href={item?.whatsappGroupLink} target='_blank' rel="noreferrer">
                                                            <Button type='primary' style={{
                                                                backgroundColor: '#25d366',
                                                            }}>
                                                                <WhatsAppOutlined />
                                                                Join Whatsapp Group
                                                            </Button>
                                                        </a>
                                                    }
                                                </>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </List.Item>
                        )}
                    />
                </Spin>
            </div>
        </Spin>
    </div>;
};
export default MyCources;